import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a8954efa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a8954efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8954efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8954efa')) {
      api.createRecord('a8954efa', component.options)
    } else {
      api.reload('a8954efa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a8954efa&scoped=true&", function () {
      api.rerender('a8954efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24EhCBt4M16o6/JS/comp/GuestBox.vue"
export default component.exports